export const breadcrumbs = {
    cosmetics: [
        { label: 'Главная', link: '/', active: false },
        { label: 'Косметика и гигиена', link: '/catalog/cosmetics', active: true }
    ],
};
